<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'BRoot',

}
</script>

<style lang="scss">
</style>
